// import { useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";

// export default function PaymentResult() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const status = params.get("status");

//     if (status === "success") {
//       navigate("/register/step/7", { replace: true });
//     } else {
//       navigate("/register/step/6?payment=failed", { replace: true });
//     }
//   }, [location, navigate]);

//   return <div className="text-center mt-20">Processing Payment...</div>;
// }

// import { useNavigate, useLocation } from "react-router-dom";
// import { useEffect } from "react";

// export default function PaymentResult() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     const status = new URLSearchParams(location.search).get("status");

//     if (status === "success") {
//       /* Restore form data */
//       const raw = localStorage.getItem("multiStepRegistration_form_v1");

//       if (raw) {
//         const parsed = JSON.parse(raw);

//         /* Save payment flag */
//         parsed.paymentDone = true;

//         localStorage.setItem(
//           "multiStepRegistration_form_v1",
//           JSON.stringify(parsed),
//         );
//       }

//       navigate("/register/step/7", { replace: true });
//     } else {
//       navigate("/register/step/6?payment=failed", { replace: true });
//     }
//   }, [location, navigate]);

//   return <div>Processing Payment...</div>;
// }

// import { useNavigate, useLocation } from "react-router-dom";
// import { useEffect } from "react";

// export default function PaymentResult() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     const status = new URLSearchParams(location.search).get("status");

//     const raw = localStorage.getItem("multiStepRegistration_form_v1");

//     if (raw) {
//       const parsed = JSON.parse(raw);

//       if (status === "success") {
//         parsed.paymentDone = true;

//         localStorage.setItem(
//           "multiStepRegistration_form_v1",
//           JSON.stringify(parsed),
//         );

//         navigate("/register/step/7", { replace: true });
//       } else {
//         navigate("/register/step/6?payment=failed", {
//           replace: true,
//         });
//       }
//     } else {
//       navigate("/register/step/6");
//     }
//   }, [location, navigate]);

//   return <div>Processing Payment...</div>;
// }

// import { useNavigate, useLocation } from "react-router-dom";
// import { useEffect } from "react";

// export default function PaymentResult() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     const status = new URLSearchParams(location.search).get("status");

//     const raw = localStorage.getItem("multiStepRegistration_form_v1");

//     if (!raw) {
//       navigate("/register/step/6", { replace: true });
//       return;
//     }

//     const parsed = JSON.parse(raw);

//     if (status === "success") {
//       /* 🔥 FORCE SAVE PAYMENT STATE */
//       parsed.paymentDone = true;

//       localStorage.setItem(
//         "multiStepRegistration_form_v1",
//         JSON.stringify(parsed),
//       );

//       /* 🔥 GO DIRECT STEP 7 */
//       navigate("/register/step/7", { replace: true });
//     } else {
//       navigate("/register/step/6?payment=failed", {
//         replace: true,
//       });
//     }
//   }, [location, navigate]);

//   useEffect(() => {
//   async function finalize() {
//     const raw = localStorage.getItem(
//       "multiStepRegistration_form_v1"
//     );

//     if (!raw) {
//       navigate("/register/step/6");
//       return;
//     }

//     const parsed = JSON.parse(raw);

//     // 🔥 Verify directly from DB
//     const res = await axios.get(
//       "/api/payment/verify",
//       { params: { email: parsed.email } }
//     );

//     if (res.data.valid) {
//       parsed.paymentDone = true;

//       localStorage.setItem(
//         "multiStepRegistration_form_v1",
//         JSON.stringify(parsed)
//       );

//       navigate("/register/step/7", { replace: true });
//     } else {
//       // wait 2 sec retry
//       setTimeout(finalize, 2000);
//     }
//   }

//   finalize();
// }, []);

//   return <div>Processing Payment...</div>;
// }

// import axios from "axios";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useEffect } from "react";

// export default function PaymentResult() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     async function finalize() {
//       const raw = localStorage.getItem("multiStepRegistration_form_v1");

//       if (!raw) {
//         navigate("/register/step/6");
//         return;
//       }

//       const parsed = JSON.parse(raw);

//       /* Retry verify until gateway updates DB */
//       const res = await axios.get("/api/payment/verify", {
//         params: { email: parsed.email },
//       });

//       if (res.data.valid) {
//         parsed.paymentDone = true;

//         localStorage.setItem(
//           "multiStepRegistration_form_v1",
//           JSON.stringify(parsed),
//         );

//         navigate("/register/step/7", { replace: true });
//       } else {
//         setTimeout(finalize, 2000);
//       }
//     }

//     finalize();
//   }, [navigate, location]);

//   return <div>Processing Payment...</div>;
// }

import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function PaymentResult() {
  const navigate = useNavigate();


  useEffect(() => {
    window.history.replaceState(null, "", window.location.href);
  }, []);

  useEffect(() => {
    let attempts = 0;

    async function checkPayment() {
      attempts++;

      const raw = localStorage.getItem("multiStepRegistration_form_v1");

      if (!raw) {
        navigate("/register/step/6");
        return;
      }

      const parsed = JSON.parse(raw);

      try {
        const res = await axios.get(
          // `${process.env.REACT_APP_API_BASE}/api/payment/verify`,
          `${process.env.REACT_APP_API_BASE || ""}/api/payment/verify`,
          { params: { email: parsed.email } },
        );

        if (res.data.valid) {
          navigate("/register/step/7", { replace: true });
          return;
        }

        if (attempts < 15) {
          setTimeout(checkPayment, 2000);
        } else {
          navigate("/register/step/6");
        }
      } catch {
        if (attempts < 15) {
          setTimeout(checkPayment, 2000);
        }
      }
    }

    checkPayment();
  }, [navigate]);

  return (
    <div className="text-center mt-20 text-lg">
      Verifying Payment... Please wait.
    </div>
  );
}